import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const OAuthOptions = () => {
  const navigate = useNavigate();
  const [loadingProvider, setLoadingProvider] = useState(null);

  const handleOAuthLogin = async (provider) => {
    setLoadingProvider(provider);
    
    // Simulate OAuth process
    setTimeout(() => {
      setLoadingProvider(null);
      navigate('/employer-dashboard');
    }, 2000);
  };

  const oauthProviders = [
    {
      id: 'google',
      name: 'Google',
      icon: 'Mail',
      color: 'bg-red-500 hover:bg-red-600',
      description: 'Continue with Google Workspace'
    },
    {
      id: 'microsoft',
      name: 'Microsoft',
      icon: 'Building',
      color: 'bg-blue-600 hover:bg-blue-700',
      description: 'Continue with Microsoft 365'
    },
    {
      id: 'linkedin',
      name: 'LinkedIn',
      icon: 'Briefcase',
      color: 'bg-blue-700 hover:bg-blue-800',
      description: 'Continue with LinkedIn Company'
    }
  ];

  return (
    <div className="bg-card rounded-xl p-6 border border-border">
      <div className="text-center mb-6">
        <h3 className="text-lg font-semibold text-foreground mb-2">
          Quick Registration Options
        </h3>
        <p className="text-sm text-muted-foreground">
          Register faster using your existing business accounts
        </p>
      </div>
      <div className="space-y-3 mb-6">
        {oauthProviders?.map((provider) => (
          <Button
            key={provider?.id}
            variant="outline"
            fullWidth
            onClick={() => handleOAuthLogin(provider?.id)}
            loading={loadingProvider === provider?.id}
            disabled={loadingProvider && loadingProvider !== provider?.id}
            className="justify-start h-12"
          >
            <div className="flex items-center space-x-3">
              <div className={`w-8 h-8 rounded-lg ${provider?.color} flex items-center justify-center text-white`}>
                <Icon name={provider?.icon} size={16} />
              </div>
              <div className="text-left">
                <div className="font-medium text-sm">{provider?.description}</div>
                <div className="text-xs text-muted-foreground">
                  Auto-fill company information
                </div>
              </div>
            </div>
          </Button>
        ))}
      </div>
      <div className="relative">
        <div className="absolute inset-0 flex items-center">
          <div className="w-full border-t border-border"></div>
        </div>
        <div className="relative flex justify-center text-sm">
          <span className="px-4 bg-card text-muted-foreground">
            Or register manually
          </span>
        </div>
      </div>
      <div className="mt-6 bg-muted/30 rounded-lg p-4">
        <div className="flex items-start space-x-3">
          <Icon name="Info" size={16} className="text-primary mt-0.5" />
          <div className="text-xs text-muted-foreground">
            <p className="mb-1">
              <strong>OAuth Benefits:</strong>
            </p>
            <ul className="space-y-1 list-disc list-inside">
              <li>Faster registration process</li>
              <li>Auto-populated company details</li>
              <li>Enhanced security with 2FA</li>
              <li>Single sign-on convenience</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OAuthOptions;